import { createContext, useContext, useState, ReactNode, useMemo } from 'react';

type WorkspaceContextType = {
  workspace: string;
  setWorkspace: (workspace: string) => void;
};

const WorkspaceContext = createContext<WorkspaceContextType | undefined>(
  undefined,
);

export function WorkspaceProvider({ children }: { children: ReactNode }) {
  const [workspace, setWorkspace] = useState('');

  const value = useMemo(
    () => ({
      workspace,
      setWorkspace,
    }),
    [workspace, setWorkspace],
  );

  return (
    <WorkspaceContext.Provider value={value}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspace() {
  const context = useContext(WorkspaceContext);
  if (!context) {
    throw new Error('useWorkspace must be used within a WorkspaceProvider');
  }
  return context;
}
